export const getLogoByDomainAndAlt = () => {
  const basePath = process.env.PUBLIC_URL || '';

  return {
    logo: `${basePath}/logos/gomedulla_light.png`,
    darkLogo: `${basePath}/logos/gomedulla_black.png`,
    alt: 'GoMedulla Logo'
  };
};